import type { ProspectFiche } from "@sfs/contracts";

export function PresentationProspect({ prospect }: { prospect: ProspectFiche }) {
  const resume = prospect.resumeActivite;
  const interlocuteurs = prospect.interlocuteurs ?? [];

  if (!resume && interlocuteurs.length === 0) return null;

  return (
    <>
      {resume && (
        <section className="panel">
          <h2 className="blocktitle">Ce qu'ils vendent</h2>
          <p style={{ margin: 0 }}>{resume}</p>
        </section>
      )}

      {interlocuteurs.length > 0 && (
        <section className="panel">
          <h2 className="blocktitle">Qui appeler</h2>
          <table>
            <thead><tr><th>Personne</th><th>Rôle</th><th>Angle</th></tr></thead>
            <tbody>
              {interlocuteurs.map(i => (
                <tr key={i.id}>
                  <td><strong>{i.prenom} {i.nom ?? ""}</strong><br /><span className="mut petit">{i.fonction}</span></td>
                  <td><span className="pill">{i.roleVente}</span></td>
                  <td>{i.angleAccroche}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}
    </>
  );
}
